import { Routes } from '@angular/router';
import {AuthGuard} from '@auth0/auth0-angular';;
import { ManageLiteLoginAccessesGuard } from '../core/guards/manage-lite-login-accesses.guard';
import { LiteLoginAccessesListComponent } from './lite-login-accesses-list/lite-login-accesses-list.component';
import { LiteLoginAccessesFormComponent } from './lite-login-accesses-form/lite-login-accesses-form.component';

export const LITE_LOGIN_ROUTES: Routes = [
  {
    path: 'lite-login',
    canActivate: [AuthGuard, ManageLiteLoginAccessesGuard],
    children: [
      { path: 'accesses', component: LiteLoginAccessesListComponent },
      { path: 'new', component: LiteLoginAccessesFormComponent, data: { mode: 'edit' } },
      { path: 'edit/:id', component: LiteLoginAccessesFormComponent, data: { mode: 'edit' } },
      { path: 'see/:id', component: LiteLoginAccessesFormComponent, data: { mode: 'readonly'} },
      { path: '**', redirectTo: '' }
    ]
  }
];
